export const SERVER_INTERNAL_ERROR = 500;

export const EMAIL_EXISTS_ERROR = 409;

export const BAD_REQUEST_ERROR = 400;

export const REQUEST_FAILED_DEPENDENCY = 424;

export const PASSWORD_EXPIRED_ERROR = 401;
